import { render, staticRenderFns } from "./MarketplaceContractOverview.vue?vue&type=template&id=5ed82522&scoped=true&"
import script from "./MarketplaceContractOverview.vue?vue&type=script&lang=js&"
export * from "./MarketplaceContractOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed82522",
  null
  
)

export default component.exports